// ** MUI Imports
import { Divider } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const FooterContent = () => {
  const { t } = useTranslation()

  return (
    <Box>
    <Divider sx={{ mb: 2, color: '#C0C0C0' }} />
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography sx={{ mr: 2 }}>
      ©   {t('Oujat. All rights reserved')} {` ${new Date().getFullYear()}`}
      </Typography>
    </Box>
  </Box>
  )
}

export default FooterContent
